"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ChecklistDropdown(props) {
  var _apiData$data, _searchState$lastFilt3;
  var {
    searchState,
    setSearchState,
    type,
    apiData
  } = props;
  var [showDropdown, setShowDropdown] = (0, _react.useState)(false);
  var [label, setLabel] = (0, _react.useState)(props.defaultLabel);
  var [selected, setSelected] = (0, _react.useState)(false);
  var [keyPrefix, setKeyPrefix] = (0, _react.useState)(Date.now());
  var searchResults = apiData === null || apiData === void 0 || (_apiData$data = apiData.data) === null || _apiData$data === void 0 ? void 0 : _apiData$data.data;
  var capitalizedType = type.charAt(0).toUpperCase() + type.slice(1);
  var pluralFormOfType = capitalizedType === 'Specialty' ? 'Specialties' : capitalizedType + 's';
  var [isMounted, setIsMounted] = (0, _react.useState)(false);

  // Set
  (0, _react.useEffect)(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  // Set selected to true if there are any items in the selection array
  (0, _react.useEffect)(() => {
    setSelected(searchState["".concat(type, "Selection")].length > 0);
    if (searchState["".concat(type, "Selection")].length > 0) {
      updateLabel();
    }
  }, []);
  var updateLabel = () => {
    if (searchState["".concat(type, "Selection")].length > 0) {
      setLabel(searchState["".concat(type, "Selection")].length == 1 ? "1 ".concat(capitalizedType) : "".concat(searchState["".concat(type, "Selection")].length, " ").concat(pluralFormOfType));
    }
  };

  // Run fucntion when ever showDropdown is changed to false, which is when the dropdown is closed
  (0, _react.useEffect)(() => {
    if (!showDropdown) searchIfFiltersAreUpdated();
  }, [showDropdown]);

  // Handle 'click' events on the Dropdown toggle.
  var toggleHandler = () => {
    setSelected(searchState["".concat(type, "Selection")].length > 0);
    setShowDropdown(!showDropdown);
  };

  // Handle 'click' events on the Apply Button.
  // Here we will update the state, which will trigger a useEffect, which recalls API data or simply filters results
  var applyHandler = e => {
    setSelected(searchState["".concat(type, "Selection")].length > 0);
    setShowDropdown(false);
    if (props.applyOnClick) props.applyOnClick(e);
  };

  // Handle 'click' events on the Dropdown items.
  var clickHandler = (e, _ref) => {
    var {
      id,
      label
    } = _ref;
    var newSelection = [];
    if (e.target.checked) {
      newSelection = [...searchState["".concat(type, "Selection")]];
      newSelection.push({
        id,
        label
      });
    } else {
      newSelection = searchState["".concat(type, "Selection")].filter(item => item.id != id);
    }
    setSearchState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        ["".concat(type, "Selection")]: newSelection
      });
    });
    var numChecked = newSelection.length;
    setLabel(numChecked === 0 ? props.defaultLabel : numChecked === 1 ? '1 item' : "".concat(numChecked, " items"));
    if (props.itemOnClick) props.itemOnClick(e);
  };

  // Handle 'click' events on the 'clear' button on the selected toggle.
  var clearHandler = e => {
    setSearchState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        ["".concat(type, "Selection")]: []
      });
    });
    setLabel(props.defaultLabel);
    setSelected(false);
    setKeyPrefix(Date.now());
    if (props.applyOnClick) props.applyOnClick(e);
    if (props.toggleOnClear) props.toggleOnClear(e);
  };
  (0, _react.useEffect)(() => {
    if (!isMounted) return;
    if (searchState["".concat(type, "Selection")].length > 0) {
      updateLabel();
    } else {
      setLabel(props.defaultLabel);
    }
  }, [searchState["".concat(type, "Selection")]]);
  var searchIfFiltersAreUpdated = () => {
    var _searchState$lastFilt, _searchState$lastFilt2;
    if (_lodash.default.isEqual(searchState === null || searchState === void 0 || (_searchState$lastFilt = searchState.lastFiltersUsed) === null || _searchState$lastFilt === void 0 ? void 0 : _searchState$lastFilt.languageSelection, searchState === null || searchState === void 0 ? void 0 : searchState.languageSelection) && _lodash.default.isEqual(searchState === null || searchState === void 0 || (_searchState$lastFilt2 = searchState.lastFiltersUsed) === null || _searchState$lastFilt2 === void 0 ? void 0 : _searchState$lastFilt2.specialtySelection, searchState === null || searchState === void 0 ? void 0 : searchState.specialtySelection)) return;else props.applyOnClick();
  };
  var shouldBeDisabled = _lodash.default.isEqual(searchState["".concat(type, "Selection")], searchState === null || searchState === void 0 || (_searchState$lastFilt3 = searchState.lastFiltersUsed) === null || _searchState$lastFilt3 === void 0 ? void 0 : _searchState$lastFilt3["".concat(type, "Selection")]);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown, {
    id: "".concat(type, "-filter-dropdown"),
    className: "dropdown--custom-control checklist-filter-dropdown",
    onToggle: toggleHandler,
    show: showDropdown,
    type: "checkbox"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Toggle, {
    id: "".concat(type, "-filter-dropdown-toggle"),
    label: label,
    onClear: clearHandler,
    selected: selected
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Menu, {
    id: "".concat(type, "-filter-dropdown-menu")
  }, (searchResults === null || searchResults === void 0 ? void 0 : searchResults["".concat(type, "facet")]) && searchResults["".concat(type, "facet")].map((option, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.CheckboxItem, {
      caption: "(".concat(option.doc_count, ")"),
      id: "".concat(type, "-").concat(option.key),
      eventKey: index,
      key: keyPrefix + option.key,
      defaultChecked: searchState["".concat(type, "Selection")].some(e => e.label === option.key),
      checked: true,
      name: option.key,
      onClick: clickHandler
    }, "".concat(option.key));
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.ApplyButton, {
    label: "Apply",
    onClick: applyHandler,
    disabled: shouldBeDisabled
  }))));
}
var _default = exports.default = ChecklistDropdown;